import { Check, Clock, Loader2, Minus, X } from 'lucide-react';

import { KubesoloStepName, KubesoloStepState } from '@api/types.gen';

import { IconMode } from '@@/Icon';

export const stepLabels: Record<KubesoloStepName, string> = {
  connect: 'Connect',
  hostKey: 'Host key',
  sudo: 'Sudo',
  arch: 'Arch',
  upload: 'Upload kubesoloctl',
  check: 'KubeSolo check',
  reachPortainer: 'Reach Portainer',
};

export const runningStepLabels: Record<KubesoloStepName, string> = {
  connect: 'Connecting',
  hostKey: 'Checking the host key',
  sudo: 'Checking sudo',
  arch: 'Checking the architecture',
  upload: 'Uploading kubesoloctl',
  check: 'Running the KubeSolo check',
  reachPortainer: 'Checking the machine can reach Portainer',
};

export const stepOrder: Array<KubesoloStepName> = [
  'connect',
  'hostKey',
  'sudo',
  'reachPortainer',
  'arch',
  'upload',
  'check',
];

export const stepStateLabels: Record<KubesoloStepState, string> = {
  passed: 'passed',
  failed: 'failed',
  running: 'running',
  pending: 'not run yet',
  skipped: 'skipped, needs an earlier step',
};

export const stepStateIcons: Record<
  KubesoloStepState,
  { icon: typeof Check; mode: IconMode; spin?: boolean }
> = {
  passed: { icon: Check, mode: 'success' },
  failed: { icon: X, mode: 'danger' },
  running: { icon: Loader2, mode: 'primary', spin: true },
  pending: { icon: Clock, mode: 'secondary' },
  skipped: { icon: Minus, mode: 'secondary' },
};
